export default __webpack_public_path__ + "static/media/check-icon.53284840.svg";